import { useState } from 'react';
import { Modal, Typography } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { telegram } from '../../utils/telegram';

interface SettingsInfoButtonProps {
  /** Modal sarlavhasi — tarjima qilingan matn */
  title: string;
  /** Tushuntirish matni — tarjima qilingan, `\n` orqali abzatslarga bo'linadi */
  body: string;
}

/**
 * Owner sozlamalari cardlari uchun info tugmasi.
 * Bosilganda card vazifasini batafsil tushuntiruvchi modal ochiladi.
 * Matnlar i18n orqali keladi (uz/ru/en).
 */
export default function SettingsInfoButton({ title, body }: SettingsInfoButtonProps) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        aria-label={title}
        onClick={(e) => {
          e.stopPropagation();
          telegram.hapticFeedback.impact('light');
          setOpen(true);
        }}
        style={{
          width: 30,
          height: 30,
          borderRadius: 8,
          border: 'none',
          background: 'transparent',
          color: 'var(--bl-text-muted, #9ca3af)',
          fontSize: 18,
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          padding: 0,
          WebkitTapHighlightColor: 'transparent',
        }}
      >
        <InfoCircleOutlined />
      </button>

      <Modal
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
        centered
        width={340}
        title={
          <span
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 8,
              fontSize: 15,
              fontWeight: 700,
              color: 'var(--bl-text-strong, #0f172a)',
            }}
          >
            <InfoCircleOutlined style={{ color: '#7c3aed', fontSize: 18 }} />
            {title}
          </span>
        }
      >
        <Typography.Paragraph
          style={{
            fontSize: 14,
            lineHeight: 1.6,
            color: 'var(--bl-text, #374151)',
            whiteSpace: 'pre-line',
            marginBottom: 0,
          }}
        >
          {body}
        </Typography.Paragraph>
      </Modal>
    </>
  );
}
